export const forgetPasswordStaticData = {
  forgetPasswordText: 'Forgot Password',
  messageText: "We'll send you a reset password link",
  emailText: 'Email',
  emailPlaceholder: 'Enter your email address',
  sendConfirmationText: 'Send Confirmation',
  validEmailText: 'Please enter a valid email address',
  privacyPolicyText: 'Privacy Policy',
  termConditionText: 'Terms & Condition',
  loginImageText: 'Illustration In Progress',
  passwordRecoveryText: 'Password Recovery',
  passwordRecoveryMessageText:
    'On your email has been sent an email containing instructions on password recovery',
  validEmailCheckText:
    'We are unable to find an account associated with this email address. Please check if the email you have provided is correct or contact your administrator for assistance.',
};

export const forgetPasswordHindiData = {
  forgetPasswordText: 'पासवर्ड भूल गए',
  messageText: 'हम आपको पासवर्ड रीसेट लिंक भेजेंगे',
  emailText: 'ईमेल',
  emailPlaceholder: 'अपना ईमेल पता दर्ज करें',
  sendConfirmationText: 'पुष्टि भेजें',
  validEmailText: 'कृपया एक मान्य ईमेल पता दर्ज करें',
  privacyPolicyText: 'गोपनीयता नीति',
  termConditionText: 'नियम और शर्तें',
  loginImageText: 'चित्रण प्रगति पर है',
  passwordRecoveryText: 'पासवर्ड पुनर्प्राप्ति',
  passwordRecoveryMessageText: 'आपके ईमेल पर पासवर्ड पुनर्प्राप्ति के निर्देश भेजे गए हैं',
  validEmailCheckText:
    'हम इस ईमेल पते से जुड़ा कोई खाता नहीं ढूंढ पा रहे हैं। कृपया जांचें कि आपने जो ईमेल प्रदान किया है वह सही है या सहायता के लिए अपने प्रशासक से संपर्क करें।',
};

export const forgetPasswordArabicData = {
  forgetPasswordText: 'نسيت كلمة المرور',
  messageText: 'سنرسل لك رابط إعادة تعيين كلمة المرور',
  emailText: 'البريد الإلكتروني',
  emailPlaceholder: 'أدخل عنوان بريدك الإلكتروني',
  sendConfirmationText: 'إرسال التأكيد',
  validEmailText: 'يرجى إدخال عنوان بريد إلكتروني صحيح',
  privacyPolicyText: 'سياسة الخصوصية',
  termConditionText: 'الشروط والأحكام',
  loginImageText: 'الرسم التوضيحي قيد التطوير',
  passwordRecoveryText: 'استرداد كلمة المرور',
  passwordRecoveryMessageText:
    'تم إرسال بريد إلكتروني إلى عنوان بريدك الإلكتروني يحتوي على تعليمات استرداد كلمة المرور',
  validEmailCheckText:
    'لا يمكننا العثور على حساب مرتبط بعنوان البريد الإلكتروني هذا. يرجى التحقق من صحة البريد الإلكتروني المقدم أو الاتصال بالمسؤول للحصول على المساعدة.',
};
